// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
export const createArrayFromStartToN = (start, n) => Array.from({ length: n - start + 1 }, (_, i) => i + start);
